import { schema } from "normalizr";

export const funktionSchema = new schema.Entity("funktionen");
